// firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage , ref, uploadBytes, getDownloadURL} from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCUGp8d6X2bfMuxC0zwmGIPjbTTm0w8jJc",
  authDomain: "fyrion3d.firebaseapp.com",
  databaseURL: "https://fyrion3d-default-rtdb.firebaseio.com",
  projectId: "fyrion3d",
  storageBucket: "fyrion3d.firebasestorage.app",
  messagingSenderId: "806581933730",
  appId: "1:806581933730:web:929898830b5311d5ebe9fb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const db = getDatabase(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
